import { render, staticRenderFns } from "./Bblist.vue?vue&type=template&id=96116452&scoped=true"
import script from "./Bblist.vue?vue&type=script&lang=js"
export * from "./Bblist.vue?vue&type=script&lang=js"
import style0 from "./Bblist.vue?vue&type=style&index=0&id=96116452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96116452",
  null
  
)

export default component.exports